var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,16c3.3789062,0,6-4.7749023,6-8.8823242C22,3.8037109,21.3183594,0,16,0s-6,3.7407227-6,7 C10,11.6259766,12.9160156,16,16,16z M16,2c2.9902344,0,4,1.2915039,4,5.1176758C20,10.6625977,17.7460938,14,16,14 s-4-3.3945312-4-7C12,3.2148438,12.9716797,2,16,2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3203125,20.4931641C26.3876953,19.5620117,22.21875,18,16,18S5.6123047,19.5620117,3.6806641,20.4931641 C2.6591797,20.984375,2,22.0424805,2,23.1879883V32h2v-8.8120117c0-0.3881836,0.2099609-0.7299805,0.5488281-0.8930664 C6.3261719,21.4379883,10.1787109,20,16,20s9.6738281,1.4379883,11.4521484,2.2949219 C27.7900391,22.4580078,28,22.7998047,28,23.1879883V32h2v-8.8120117C30,22.0424805,29.3408203,20.984375,28.3203125,20.4931641z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSmall);
export default __webpack_public_path__ + "static/media/account--small.49e845d4ca408401bfb2c84da4f73836.svg";
export { ForwardRef as ReactComponent };